import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Patient, Caregiver } from '@drl/shared/models';
import { Gender, genderMap } from '@drl/core/auth/models/gender.enum';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@drl/core/auth/models/user.model';
import { AGE_THRESHOLD } from '@drl/core/auth/models/patient-types.enum';
import { Administer } from '@drl/shared/utility/patients-caregiver-utility.enum';


@Component({
  selector: 'drl-patient-details-card',
  templateUrl: './patient-details-card.component.html',
  styleUrls: ['./patient-details-card.component.scss'],
})
export class PatientDetailsCardComponent implements OnInit, OnChanges {
  isHospitalAdminster: boolean;
  neutralIconPath = './assets/neutral-icon.svg';
  neutralIconPath1 = './assets/neutral-icon-square.svg';
  comorbidities = [];
  constructor(private readonly translateSvc: IpsTranslateService) {
    this.translate = this.translateSvc.translate;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.patient?.genderEnum) {
      const isFemale = this.GenderMap[this.patient?.genderEnum].id == this.GenderMap[Gender.Female].id;
      if (this.patient?.age < AGE_THRESHOLD && isFemale) {
        this.isBlueTheme = false;
      }
    }
    if (this.patient?.location) {
      this.isHospitalAdminster = Administer.AT_HOSPITAL.toString() === this.patient.location
    }

    if (this.patient?.photo === this.neutralIconPath) {
      this.patient.photo = this.neutralIconPath1;
    }
    if(this.patient?.comorbidity){
      this.comorbidities = this.patient.comorbidity.split(',');
      this.patient.comorbidity = this.patient.comorbidity.replace(/,(\S)/g, ', $1');
    }
    if(!this.caregiver){
      this.caregiver={
        photo: this.neutralIconPath,
      } as Caregiver & User;
    }
    if(!this.caregiver?.photo){
      this.caregiver.photo = this.neutralIconPath;
    }

  }
  @Input() patient: Patient & User;
  @Input() caregiver: Caregiver & User;
  @Input() careGroupname: string;

  isBlueTheme = true;

  GenderMap = genderMap(this.translateSvc.translate);
  translate: TranslateService;

  ngOnInit() {
    // do nothing.
  }

}
